import {observer} from 'mobx-react-lite'
import React, {useRef} from 'react'
import {DataObjectId} from 'yougile-model'
import {IconButton} from '@components/common/base/buttons'
import {Dropdown} from '@components/common/dropdown/dropdown'
import {ProjectsFlatTreeDropdownContent} from '@components/common/projects-tree/projects-tree'
import {useBoolean} from '@containers/hooks'
import {useMultiActionsWithTasksStore} from '../multi-actions-with-tasks-store'

export const Move = observer(() => {
  const ref = useRef<HTMLElement>(null)
  const [, store] = useMultiActionsWithTasksStore()
  const moveOpen = useBoolean(false)
  const onChange = (locationId: DataObjectId) => {
    store.moveAll(locationId)
    moveOpen.turnOff()
  }
  return (
    <>
      <IconButton
        ref={ref}
        icon="IconArrowForwardUp"
        onClick={moveOpen.toggle}
        size="small"
        wrapperSize="big"
        className="-m-4"
        color="secondary"
        forcedState={moveOpen.value ? 'active' : undefined}
      />
      {moveOpen.value && (
        <Dropdown
          reference={ref}
          visible
          onVisibleChange={() => moveOpen.setValue(false)}
          content={<ProjectsFlatTreeDropdownContent onChange={onChange} />}
          hideArrow
          theme="new-menu"
        />
      )}
    </>
  )
})
